import React, { useState, useEffect  } from "react";
import {  NavLink } from "react-router-dom";
import logo from "../../../assets/images/dta-finder.svg";
import LoginComponent from "../../user/login/login";
import AdminLoginComponent from "../../user/login/admin-login";
import ForgotPwdComponent from "../../user/forgotpassword/forgotpassword";
import { mapStateToProps } from "../../../redux/reducers";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import HelpComponent from "../../user/help";

const Header = (props) => {
  const [modalShown, toggleModal] = useState(false);
  const [modalShownAdmin, toggleModalAdmin] = useState(false);
  const [forgotShown, toggleForgotModal] = useState(false);
  const [helpModalShow, setHelpModalShow] = useState(false);
  const [language, setLanguage] = useState({});


  useEffect(() => {
    setLanguage(props.language)
  }, [props.language])
 
  const openForgotPwd = () => {
    toggleForgotModal(true);
  };

  return (
    <>
      {forgotShown ?
        (
          <ForgotPwdComponent
            shown={forgotShown}
            close={() => {
              toggleForgotModal(false);
            }}
          />
        )
        : (
          ""
        )}
        {helpModalShow ?
        (
          <HelpComponent
            shown={helpModalShow}
            close={() => {
              setHelpModalShow(false);
            }}
            language={language}
          />
        )
        : (
          ""
        )}
      <div className="header">
      {modalShown && (
            <LoginComponent
              shown={modalShown}
              close={(forgotpwd = "") => {
                toggleModal(false);
                if (forgotpwd) {
                  openForgotPwd();
                }
              }}
              language={language}
            />
          )}
          {modalShownAdmin && (
            <AdminLoginComponent
              shown={modalShownAdmin}
              close={(forgotpwd = "") => {
                toggleModalAdmin(false);
                if (forgotpwd) {
                  openForgotPwd();
                }
              }}
              language={language}
            />
          )}
        
          <nav className="navbar navbar-expand-lg navbar-light" aria-label="main">
            <NavLink to="/" reloadDocument="true">
              <img
                src={logo}
                alt="DTA Finder home"
                className="header-logo-responsive mr-0"
                // tabIndex={1}
              />
              
              <h1 className="boldFont page-title header-title" style={{display:'inline'}} aria-hidden='true'>
              {language["DTA Finder"]}
              </h1>
            </NavLink>
        
          </nav>
        {/* )} */}
      </div>
    </>
  );
};

Header.propTypes = {
  vendorDetails: PropTypes.object,
  language: PropTypes.object,
  mapdata: PropTypes.object,
  selectedLanguage:PropTypes.string,
  userAuth:PropTypes.object,
  authUserDetails:PropTypes.func,
};

export default connect(
  mapStateToProps
)(Header);
